import isString from 'lodash/isString';

const EXPIRED_TIME_CONFIG_KEY = 'expireTimeStorage';
const DEFAULT_EXPIRED_DAYS = 3;
const DEFAULT_EXPIRED_TIME = Number(
  new Date().setDate(new Date().getDate() + DEFAULT_EXPIRED_DAYS)
);

const localStorageGet = (name) => {
  if (window && window.localStorage) {
    return window.localStorage.getItem(name);
  }
  console.error('Window local storage is not available');

  return null;
};

const localStorageSet = (name, value) => {
  if (window && window.localStorage) {
    return window.localStorage.setItem(name, value);
  }
  console.error('Window local storage is not available');

  return null;
};

const getExpireTime = (expiredKey) => {
  const storageValue = localStorageGet(EXPIRED_TIME_CONFIG_KEY);
  const expiredStorageData = isString(storageValue)
    ? JSON.parse(storageValue)
    : {};

  return expiredStorageData[expiredKey] || null;
};

const setExpireTime = (
  expiredKey,
  expiredMilliseconds = DEFAULT_EXPIRED_TIME
) => {
  const storageValue = localStorageGet(EXPIRED_TIME_CONFIG_KEY);
  const expiredStorageData = isString(storageValue)
    ? JSON.parse(storageValue)
    : {};

  expiredStorageData[expiredKey] = expiredMilliseconds;

  return localStorageSet(
    EXPIRED_TIME_CONFIG_KEY,
    JSON.stringify(expiredStorageData)
  );
};

const resetExpireTime = (expiredKey) => {
  const storageValue = localStorageGet(EXPIRED_TIME_CONFIG_KEY);
  const expiredStorageData = isString(storageValue)
    ? JSON.parse(storageValue)
    : {};

  delete expiredStorageData[expiredKey];

  return localStorageSet(
    EXPIRED_TIME_CONFIG_KEY,
    JSON.stringify(expiredStorageData)
  );
};

const checkExpireTimeIsUp = (expiredKey) =>
  getExpireTime(expiredKey) != null
    ? getExpireTime(expiredKey) > Number(new Date())
    : false;

export {
  localStorageGet,
  localStorageSet,
  getExpireTime,
  setExpireTime,
  checkExpireTimeIsUp,
  resetExpireTime,
};
